$(document).on('click', '#profile-remove-avatar', () => {
  $('#profile-avatar-preview').attr('src', '').addClass('!hidden');
  $('#recruiter_image_attributes__destroy').val('true');
});

$(document).on('change', '#recruiter_image_attributes_file', (e) => {
  const file = $(e.target).get(0).files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      $('#profile-avatar-preview').attr('src', event.target.result).removeClass('!hidden');
    };
    reader.readAsDataURL(file);

    $('#recruiter_image_attributes__destroy').val('false');
  }
});
